export const TgIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5527 13.9462C10.2999 14.1731 10.3195 14.575 10.5931 14.7763L16.7324 19.2932C17.4914 19.7162 18.0261 19.4935 18.2309 18.595L20.9473 5.8662C21.1881 4.74422 20.5423 4.30473 19.8029 4.57997L3.83562 10.6931C2.74589 11.1161 2.76239 11.7236 3.65037 11.9989L7.26293 13.1225C7.56106 13.2152 7.8848 13.1733 8.14948 13.0077L17.2146 7.33543C17.6609 7.03993 18.0666 7.20343 17.7329 7.49893L10.5527 13.9462Z"
          fill='#ffffff'/>
  </svg>
);